import React, { FC } from "react";
import { Card, Typography } from "antd";
import { PerfumeResponse } from "../../../types/types";
import "./OrderItem.css";

type PropsType = {
  perfume: PerfumeResponse;
  quantity?: number;
};

const OrderItem: FC<PropsType> = ({ perfume, quantity }) => {
  const qty = quantity ?? 1;
  const effectiveDiscount = perfume.discount
    ? (perfume.actualPrice ?? perfume.price) * (perfume.discount / 100)
    : 0;
  const discountedPrice =
    (perfume.actualPrice ?? perfume.price) - effectiveDiscount;

  return (
    <div className="order-item-card">
      <img src={perfume.filename} alt={perfume.perfumeTitle} />
      <div className="order-item-details">
        <h4>{perfume.perfumeTitle}</h4>
        <p>{perfume.brand}</p>
        <p>Qty: {qty}</p>
      </div>
      <Typography.Text strong>
        ₹{(discountedPrice * qty).toFixed(2)}
      </Typography.Text>
    </div>
  );
};

export default OrderItem;
